import React from 'react';
import { Form } from 'react-bootstrap';
import { ClearableDropdownField } from '../../common';

/**
 * MLB category + MLB subcategory fields (Mercado Livre link).
 * Used in both create and edit branches of CategoryForm; idPrefix distinguishes dropdown ids.
 * @param {string} [idPrefix] - Suffix for dropdown ids, e.g. 'edit' => mlb-category-dropdown-edit
 */
const MlbCategoryFields = ({
  idPrefix = '',
  formData,
  mlbCategoryFieldEnabled,
  mlbChildFieldEnabled,
  showMlbCategoryDropdown,
  setShowMlbCategoryDropdown,
  showMlbChildDropdown,
  setShowMlbChildDropdown,
  mlbCategoryDropdownRef,
  mlbChildDropdownRef,
  mlbCategoryOptions,
  mlbChildOptions,
  mlbCategoriesLoading,
  mlbChildrenLoading,
  handleSelectMlbCategory,
  handleSelectMlbChild,
  clearMlbCategory,
  clearMlbChild
}) => {
  const categoryId = idPrefix ? `mlb-category-dropdown-${idPrefix}` : 'mlb-category-dropdown';
  const childId = idPrefix ? `mlb-child-dropdown-${idPrefix}` : 'mlb-child-dropdown';

  return (
    <>
      <Form.Group className="mb-3">
        <Form.Label>MLB category (Mercado Livre)</Form.Label>
        <ClearableDropdownField
          ref={mlbCategoryDropdownRef}
          value={formData.mlbCategoryDisplayName}
          placeholder={mlbCategoryFieldEnabled ? 'Select… (search uses Category name)' : 'Fill in Category name first'}
          disabled={!mlbCategoryFieldEnabled}
          loading={mlbCategoriesLoading}
          loadingMessage="Loading MLB categories…"
          showDropdown={showMlbCategoryDropdown && mlbCategoryFieldEnabled && !mlbCategoriesLoading}
          options={mlbCategoryOptions}
          emptyMessage="No matching MLB categories"
          getLabel={(row) => row.category_name?.trim() || row.category_id || '(Unnamed)'}
          getItemKey={(item) => item.category_id || item.category_name}
          onSelect={handleSelectMlbCategory}
          onFocus={() => mlbCategoryFieldEnabled && setShowMlbCategoryDropdown(true)}
          onClick={() => mlbCategoryFieldEnabled && setShowMlbCategoryDropdown(true)}
          onClear={clearMlbCategory}
          hasValue={!!formData.mlb_category_id}
          id={categoryId}
          clearTitle="Clear MLB category"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>MLB subcategory (optional)</Form.Label>
        <ClearableDropdownField
          ref={mlbChildDropdownRef}
          value={formData.mlbCategoryChildDisplayName}
          placeholder={mlbChildFieldEnabled ? 'Select…' : 'Select an MLB category first'}
          disabled={!mlbChildFieldEnabled}
          loading={mlbChildrenLoading}
          loadingMessage="Loading subcategories…"
          showDropdown={showMlbChildDropdown && mlbChildFieldEnabled && !mlbChildrenLoading}
          options={mlbChildOptions}
          emptyMessage="No subcategories"
          getLabel={(row) => row.child_name?.trim() || row.child_id || '(Unnamed)'}
          getItemKey={(item) => item.child_id || item.child_name}
          onSelect={handleSelectMlbChild}
          onFocus={() => mlbChildFieldEnabled && setShowMlbChildDropdown(true)}
          onClick={() => mlbChildFieldEnabled && setShowMlbChildDropdown(true)}
          onClear={clearMlbChild}
          hasValue={!!formData.mlb_category_child_id}
          id={childId}
          clearTitle="Clear MLB subcategory"
        />
      </Form.Group>
    </>
  );
};

export default MlbCategoryFields;
